import { render, staticRenderFns } from "./ServiciosCrud.vue?vue&type=template&id=0162cfef"
import script from "./ServiciosCrud.vue?vue&type=script&lang=js"
export * from "./ServiciosCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports